import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../api/axios';

export default function ConnectShopify() {
  const navigate = useNavigate();
  const { selectedBusiness } = useAuth();
  const bizId = selectedBusiness?.id;
  const [domain, setDomain] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const connect = async (e) => {
    e.preventDefault();
    if (!domain) return setError('Enter your Shopify domain');
    if (!bizId) return setError('No business selected — please log in again');
    setLoading(true);
    setError('');
    const cleanDomain = domain.trim().toLowerCase().replace('https://', '').replace('http://', '').replace(/\/$/, '');
    try {
      const res = await api.post('/shopify/connect-shopify', { shopifyDomain: cleanDomain, business_id: bizId });
      if (res.data.success) {
        setSuccess('Shopify connected successfully!');
        setTimeout(() => navigate('/integrations?shopify=connected'), 1200);
      } else {
        setError(res.data.error || 'Connection failed');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Connection failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #0f8f5f, #0c7a50)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem', fontFamily: 'DM Sans, sans-serif' }}>
      <div style={{ background: '#fff', borderRadius: '18px', boxShadow: '0 20px 50px rgba(0,0,0,.15)', width: '100%', maxWidth: '440px', padding: '2rem' }}>

        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <div style={{ width: '48px', height: '48px', background: '#25D366', borderRadius: '12px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: '0.75rem' }}>
            <span style={{ color: '#fff', fontSize: '1.25rem', fontWeight: 700 }}>V</span>
          </div>
          <h1 style={{ fontSize: '1.375rem', fontWeight: 700, color: '#111' }}>Connect Your Shopify Store</h1>
          <p style={{ color: '#6b7280', fontSize: '0.875rem', marginTop: '0.25rem' }}>Sync your orders, products &amp; inventory</p>
        </div>

        <div style={{ background: '#e8f8ef', border: '1px solid #b7ecc9', borderRadius: '12px', padding: '16px', marginBottom: '1.5rem' }}>
          <h3 style={{ margin: '0 0 12px', color: '#0f8f5f', fontSize: '14px', fontWeight: 600 }}>📋 How to connect:</h3>
          <ol style={{ margin: 0, paddingLeft: '20px', color: '#4b5563', lineHeight: '2', fontSize: '13px' }}>
            <li>Login to your <strong>Shopify Admin</strong></li>
            <li>Go to <strong>Settings → Apps → Shopify App Store</strong></li>
            <li>Search <strong>"V-Bot"</strong> and click Install</li>
            <li>Open V-Bot app → Click <strong>Connect &amp; Sync</strong></li>
            <li>Enter your VFlow email &amp; password</li>
            <li>Come back here and enter your store domain below</li>
          </ol>
        </div>

        {error && (
          <div style={{ background: '#fee2e2', color: '#dc2626', padding: '0.75rem', borderRadius: '8px', marginBottom: '1rem', fontSize: '0.875rem' }}>
            {error}
          </div>
        )}
        {success && (
          <div style={{ background: '#d1fae5', color: '#065f46', padding: '0.75rem', borderRadius: '8px', marginBottom: '1rem', fontSize: '0.875rem' }}>
            ✅ {success}
          </div>
        )}

        <form onSubmit={connect}>
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: 500, marginBottom: '0.25rem' }}>
              Shopify Store Domain
            </label>
            <input
              style={{ width: '100%', border: '1px solid #d1d5db', borderRadius: '8px', padding: '0.625rem 0.75rem', fontSize: '0.875rem', boxSizing: 'border-box' }}
              placeholder="yourstore.myshopify.com"
              value={domain}
              onChange={e => setDomain(e.target.value)}
            />
            <p style={{ fontSize: '0.75rem', color: '#9ca3af', marginTop: '0.25rem' }}>
              Example: yourstorename.myshopify.com
            </p>
          </div>
          <button type="submit" disabled={loading}
            style={{ width: '100%', background: '#25D366', color: '#fff', border: 'none', borderRadius: '8px', padding: '0.75rem', fontSize: '0.875rem', fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1, marginBottom: '0.75rem' }}>
            {loading ? 'Connecting...' : '🔗 Activate & Connect'}
          </button>
          <button type="button" onClick={() => navigate('/integrations')}
            style={{ width: '100%', background: 'none', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '0.75rem', fontSize: '0.875rem', color: '#6b7280', cursor: 'pointer' }}>
            Skip for now →
          </button>
        </form>
      </div>
    </div>
  );
}
